import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import DiarioService from '../../../../../services/diario-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';






const Diario = () => {
    let { id } = useParams()

    const [edicao, setEdicao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [numAnexos, setNumAnexos] = useState("");
    const [anexos, setAnexos] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchDiario(id) {
        const response = await DiarioService.diarioEdit(id);
        Moment.locale();
        setEdicao(response.data["edicao"]);
        setDataPub(Moment(response.data["data_p"]).utc(false).format("yyyy-MM-DD"));
        setAno(response.data["ano"]);
        setMes(response.data["mes"]);
        setNumAnexos(response.data["num_anexos"]);
        setAnexos(response.data["anexos"]);
    }

    useEffect(() => {
        fetchDiario(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const diario = await DiarioService.editar(id, {
                edicao: edicao,
                data_p: dataPub,
                mes: mes,
                ano: ano,
                num_anexos: numAnexos,
                anexos: anexos
            })
            if (diario.data["cod_diario"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Edicao">
                                <FloatingLabel
                                    label="Edição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="edicao"
                                        value={edicao}
                                        onChange={e => setEdicao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataDiario">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data_p"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Mês">
                                <FloatingLabel
                                    label="Mês"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Mês"
                                        name="mes"
                                        onChange={e => setMes(e.target.value)}
                                    >
                                        <option value={mes}>{mes}</option>
                                        <option value="1">Janeiro</option>
                                        <option value="2">Fevereiro</option>
                                        <option value="3">Março</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Maio</option>
                                        <option value="6">Junho</option>
                                        <option value="7">Julho</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={3}>
                        <Col lg={2}>
                            <Form.Group className="mb-3" controlId="Anexos?">
                                <Form.Check
                                    type="switch"
                                    id="numAnexos"
                                    name="numAnexos"
                                    checked={numAnexos}
                                    onChange={e => setNumAnexos(e.target.checked)}
                                    label="Tem anexos?"
                                />
                            </Form.Group>
                        </Col>
                        {numAnexos ?
                            <Col>
                                <Form.Group className="mb-3" controlId="anexos">
                                    <FloatingLabel
                                        label="Anexo"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            name="anexos"
                                            value={anexos}
                                            onChange={e => setAnexos(e.target.value)}
                                            placeholder="Cole aqui o link" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col> : ''}
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/diario/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Diário editado com sucesso!</Alert>
                <Navigate to={'/restrito/diario/listar'} />
            </Fragment>
        )
    }
}

export default Diario;